import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type CustomerFavorites } from '../../../../../../src/types/CustomerFavorites';
export { type CustomerFavorites } from '../../../../../../src/types/CustomerFavorites';

interface PostFavoritePairingPostBody {
  pairing_id: number;
}

export interface PostFavoritePairingParams {
  customerId: number;
  body: PostFavoritePairingPostBody;
}

export function postFavoritePairingPath({
  customerId,
}: Pick<PostFavoritePairingParams, 'customerId'>) {
  return `/api/v2/customers/${customerId}/favorite_pairings/`;
}

export async function postFavoritePairing({
  customerId,
  body,
}: PostFavoritePairingParams) {
  return await send<CustomerFavorites>({
    path: postFavoritePairingPath({ customerId }),
    method: 'POST',
    body,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
      'Content-Type': 'application/json',
    }),
  });
}
